<template>
    <div>
        <section id="banner" class="wow animate__animated animate__fadeInRightBig">
            <img src="../assets/img/banners/banner-home.webp" class="w-100 d-none d-md-block" alt="Banner Desktop e Tablet">
            <img src="../assets/img/banners/banner-mobile.webp" class="w-100 d-block d-md-none" alt="Banner Mobile">
        </section>

        <section id="fresto" class="wow animate__animated animate__fadeInLeftBig">
            <div class="container">
                <div class="row d-flex justify-content-center align-items-center">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <img src="../assets/img/fresto_01.webp" class="w-100 wow animate__animated animate__fadeInUpBig" alt="">
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="fresto-text">
                            <h1 class="h1-x">
                                <span>Conheça o Fresto</span>
                            </h1>

                            <h3>Lorem Ipsum is simply the printing and typesetting</h3>

                            <p class="mb-5">
                                It is a long established fact that a reader will be distracted
                                by the readable content of a page when looking at its layout.
                            </p>

                            <button class="btn btn-lg btn-outline-primary" onclick="window.location.href='/conheca-fresto';">
                                + Saiba Mais
                            </button>
                        </div>
                    </div>
                </div>
            </div>            
        </section>

        <div class="position-relative">
            <img src="../assets/img/prato_01.webp" class="fresto-food-e wow animate__animated animate__fadeInUp" alt="Prato">
        </div>

        <section id="unidades" class="wow animate__animated animate__fadeInRightBig">
            <div class="container-unidades">
                <div class="unidades">
                    <h1 class="h1-y text-center mb-5">Unidades</h1>

                    <p class="text-center mb-4">
                        Passar o mouse sobre as fotos!
                    </p>

                    <div class="row">
                        <div class="col-sm-12 col-md">
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div class="flip-card-front">
                                        <div class="flip-card-txt">
                                            <p class="text-center unidade-name">
                                                <b>Clube Paineiras</b>
                                            </p>
                                        </div>
                                        <img src="../assets/img/unidades/unidade-1.jpg" class="w-100" alt="Unidade">
                                    </div>
                                    <div class="flip-card-back">
                                        <p class="text-center text-horario">
                                            Av. Dr. Alberto Penteado, 605<br>
                                            Jardim Silvia, São Paulo - SP
                                        </p>
                                        <p class="text-center text-horario mb-2">
                                            <small>
                                                <b>Horário de Funcionamento:</b><br>
                                                Segunda: 7h às 22h.<br>
                                                Terça a sexta: 7h às 23h.<br>
                                                Sábado, domingo e feriado: 9h às 22h
                                            </small>
                                        </p>
                                        <p><small><b>* acesso exclusivo a associados</b></small></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md">
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div class="flip-card-front">
                                        <div class="flip-card-txt">
                                            <p class="text-center unidade-name">
                                                <b>Clube Pinheiros</b>
                                            </p>
                                        </div>
                                        <img src="../assets/img/unidades/unidade-1.jpg" class="w-100" alt="Unidade">
                                    </div>
                                    <div class="flip-card-back">
                                        <p class="text-center text-horario">
                                            R. Angelina Maffei Vita, 259<br>
                                            Pinheiros, São Paulo - SP
                                        </p>
                                        <p class="text-center text-horario mb-2">
                                            <small>
                                                <b>Horário de Funcionamento:</b><br>                                            
                                                Segunda: 7h às 22h.<br>
                                                Terça a sexta: 7h às 23h.<br>
                                                Sábado, domingo e feriado: 9h às 22h
                                            </small>
                                        </p>
                                        <p><small><b>* acesso exclusivo a associados</b></small></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md">
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div class="flip-card-front">
                                        <div class="flip-card-txt">
                                            <p class="text-center unidade-name mb-2">
                                                <b>Clube Hebraica</b>
                                            </p>
                                        </div>
                                        <img src="../assets/img/unidades/unidade-1.jpg" class="w-100" alt="Unidade">
                                    </div>
                                    <div class="flip-card-back">
                                        <p class="text-center text-horario">
                                            R. Angelina Maffei Vita, 450,<br>
                                            Pinheiros, São Paulo - SP
                                        </p>
                                        <p class="text-center text-horario mb-2">
                                            <small>
                                                <b>Horário de Funcionamento:</b><br>                                            
                                                Segunda: 7h às 22h.<br>
                                                Terça a sexta: 7h às 23h.<br>
                                                Sábado, domingo e feriado: 9h às 22h
                                            </small>
                                        </p>
                                        <p class="text-horario"><small><b>* acesso permitido a visitantes de Seg. a Sex. das 12h às 15h</b></small></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md">
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div class="flip-card-front">
                                        <div class="flip-card-txt">
                                            <p class="text-center unidade-name">
                                                <b>Vila Olímpia</b>
                                            </p>
                                        </div>
                                        <img src="../assets/img/unidades/unidade-1.jpg" class="w-100" alt="Unidade">
                                    </div>
                                    <div class="flip-card-back">
                                        <p class="text-center">
                                            R. Ramos Batista, 267<br>
                                            Vila Olímpia, São Paulo - SP
                                        </p>
                                        <p class="text-center text-horario mb-2">
                                            <small>
                                                <b>Horário de Funcionamento:</b><br>
                                                De segunda a sexta,<br>
                                                das 11h30 às 15h30
                                            </small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md">
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div class="flip-card-front">
                                        <div class="flip-card-txt">
                                            <p class="text-center unidade-name">
                                                <b>Alphaville Tenis Clube</b>
                                            </p>
                                        </div>
                                        <img src="../assets/img/unidades/unidade-1.jpg" class="w-100" alt="Unidade">
                                    </div>
                                    <div class="flip-card-back">
                                        <p class="text-center">
                                            R. Ramos Batista, 267<br>
                                            Vila Olímpia, São Paulo - SP
                                        </p>
                                        <p class="text-center text-horario mb-0">
                                            <small>
                                                <b>Horário de Funcionamento:</b><br>                                            
                                                De segunda a sexta,<br>
                                                das 11h30 às 15h30
                                            </small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--<p class="text-center mt-5">
                        <a href="/unidades" class="btn btn-lg btn-white">
                            + Saiba Mais
                        </a>
                    </p>-->

                </div>
            </div>            
        </section>

        <div class="section-wood">
            <img src="../assets/img/prato_02.webp" class="fresto-food-s wow animate__animated animate__fadeInUp" alt="">
        </div>

        <section id="instagramFresto" class="wow animate__animated animate__fadeInLeftBig">
            <div class="container">
                <div class="frestofood">
                    <h1 class="h1-y2 text-center mb-5">
                        <img src="../assets/img/instagram-icon.svg" class="me-2" alt="">
                        Siga @frestofood
                    </h1>

                    <p class="text-center">
                        Confira o Instagram da <b>Fresto</b>! Veja as últimas fotos e fique por dentro de tudo que está
                        rolando.
                    </p>

                    <div id="instafeed" class="row"></div>
                </div>
            </div>
        </section>
        
        <div class="section-wood">
            <img src="../assets/img/prato_03.webp" class="fresto-food-e wow animate__animated animate__fadeInUp" alt="Prato">
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConhecaFresto'
};
</script>